import { FC, PropsWithChildren } from 'react'

import clsx from 'clsx'

import styles from './FooterListItem.module.scss'

type Props = {
  className?: string
}

export const FooterListItem: FC<PropsWithChildren<Props>> = ({ className, children }) => {
  return <li className={clsx(styles.container, className)}>{children}</li>
}
